export const SET_IS_LOGGED = 'SET_IS_LOGGED@headerLogin';
